import * as ko from 'knockout';
import entityBase from 'entityBase';
import { address } from 'entitiesE';

export class place_address extends entityBase {
    address_id  : KnockoutObservable<number>;
    address_type: KnockoutObservable<string>;
    place_id    : KnockoutObservable<string>;
    address     : KnockoutObservable<address>;

    constructor(item: any){
        super();
        this.address_id   = ko.observable(item.address_id);
        this.address_type = ko.observable(item.address_type).extend({ maxLength: 128 });
        this.place_id     = ko.observable(item.place_id).extend({ maxLength: 32 });
        this.address      = ko.observable();
        if(item.address) {
            this.address(new address(item.address));
        }
    }
}


